import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { formatDate } from '../../lib/format';
import { Tag } from '../primitives/Tag';
import type { Article } from '../../content/schemas';

interface ArticleRowProps {
  article: Article;
}

const Row = styled(Link)`
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) auto;
  gap: ${(p) => p.theme.step[5]}px;
  align-items: baseline;
  padding: ${(p) => p.theme.step[4]}px 0;
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
  color: inherit;

  &:hover h3 {
    color: ${(p) => p.theme.color.accent.amber};
  }
`;

const Date = styled.span`
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
`;

const Title = styled.h3`
  margin: 0;
  font-family: ${(p) => p.theme.font.serif};
  font-size: ${(p) => p.theme.step[5]}px;
  letter-spacing: -0.01em;
  transition: color 160ms ${(p) => p.theme.ease};
`;

const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Author = styled.span`
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
`;

export function ArticleRow({ article }: ArticleRowProps) {
  return (
    <Row to={`/research/${article.id}`}>
      <Date>{formatDate(article.date)}</Date>
      <Meta>
        <Title>{article.title}</Title>
        <Author>
          {article.author} · {article.read} min
        </Author>
      </Meta>
      <Tag>{article.cat}</Tag>
    </Row>
  );
}
